if (!customElements.get('wls-accordion')) {
    class WLSAccordion extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          open: 'is-open',
          header: 'js-wls-accordion-header',
          panel: 'js-wls-accordion-panel',
          group: 'js-wls-accordion-group'
        };

        this.header = this.querySelector(`.${this.classes.header}`);
        this.panel = this.querySelector(`.${this.classes.panel}`);
        this.toggle = this.toggle.bind(this);
      }

      connectedCallback() {
        if (this.header) {
          this.header.addEventListener('click', this.toggle);
        }

        // If an accordion is rendered open, let its panel size to content.
        if (this.panel && this.classList.contains(this.classes.open)) {
          this.panel.style.height = 'auto';
        }

        this.initGroup();
      }

      disconnectedCallback() {
        if (this.header) {
          this.header.removeEventListener('click', this.toggle);
        }
      }

      initGroup() {
        const group = this.closest(`.${this.classes.group}`);
        if (!group || group.dataset.initialized) return;

        const first = group.querySelector('wls-accordion');

        if (first) {
          // first.classList.add(this.classes.open);

          const index = first.dataset.index;
          const images = group.querySelectorAll('[data-accordion-image]');

          images.forEach(img => {
            if (img.dataset.accordionImage === index) {
              img.setAttribute('data-active', 'true');
            } else {
              img.removeAttribute('data-active');
            }
          });
        }

        group.dataset.initialized = "true";
      }

      open() {
        this.classList.add(this.classes.open);

        const panel = this.panel;
        if (!panel) return;

        // Animate from the current height (0) up to the content height,
        // then release to 'auto' so the panel reflows with its content.
        panel.style.height = `${panel.scrollHeight}px`;

        const onEnd = (event) => {
          if (event.target !== panel || event.propertyName !== 'height') return;
          panel.style.height = 'auto';
          panel.removeEventListener('transitionend', onEnd);
        };

        panel.addEventListener('transitionend', onEnd);
      }

      close() {
        const panel = this.panel;

        if (!panel) {
          this.classList.remove(this.classes.open);
          return;
        }

        // Lock the current height in pixels, then collapse to 0 on the next
        // frame so the browser has a concrete value to transition from.
        panel.style.height = `${panel.scrollHeight}px`;
        panel.offsetHeight; // force reflow

        requestAnimationFrame(() => {
          this.classList.remove(this.classes.open);
          panel.style.height = '0px';
        });
      }

      toggle() {
        const group = this.closest(`.${this.classes.group}`);
        const isOpen = this.classList.contains(this.classes.open);

        if (!group) {
          isOpen ? this.close() : this.open();
          return;
        }

        // Single-open behaviour: close any other open accordion in the group.
        group.querySelectorAll('wls-accordion').forEach(acc => {
          if (acc !== this && acc.classList.contains(this.classes.open)) {
            acc.close();
          }
        });

        isOpen ? this.close() : this.open();

        const index = this.dataset.index;
        const images = group.querySelectorAll('[data-accordion-image]');

        images.forEach(img => {
          if (img.dataset.accordionImage === index) {
            img.setAttribute('data-active', 'true');
          } else {
            img.removeAttribute('data-active');
          }
        });
      }
    }

    customElements.define('wls-accordion', WLSAccordion);
  }
